import React from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import {Uploader} from 'go/components/common/attachments';
import ProjectSiteItem from './ProjectSiteItem';
import {FemaGoTable} from 'app-ui-componentlibrary';
import {FemaGoModal} from 'app-ui-componentlibrary';
import {DeleteModal} from 'app-ui-componentlibrary';
import {InlineSelect} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {Alert} from 'componentLibrary';
import {mapLocationRefDataByIdOrCode} from 'common/utils';
import {unpartitionedToggleIsOn} from 'common/storeUtils';
import {
  MODALS,
  ADD_LOCATION_METHOD_CHANGE_OPTIONS,
  PROPERTY_TYPES_LABELS,
  PROPERTY_TYPES_CODES,
} from './constants';
import {Button, Icon, Loader, Grid, Dimmer, Dropdown} from 'semantic-ui-react';
import REST from 'go/requests/rest';
import _ from 'lodash';
import {NEW_ITEM} from './constants';
import {getFirstObjectError} from 'common/utils';
import {SET_LOCATION_SITE_STORE, REMOVE_LOCATION_SITE_STORE} from 'common/types';
import {Toggle} from 'componentLibrary';
import {ContentDispatch} from 'framework';
import {forceJsonResponse, MONO, FLUX} from 'common/utils';
export class ProjectSiteInventory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      items: [],
      selectedItem: false,
      openModal: MODALS.NONE,
      inventoryList: [],
      structureTypes: [],
      propertyOwnerTypes: [],
      propertyInventoryTypes: [],
      benefitCostTypes: [],
      propertyFoundationTypes: [],
      floodZoneTypes: [],
      inventoryItem: {},
      inventoryListError: '',
      uploadFileError: '',
      projectSiteDetailsError: '',
      itemToBeDeleted: '',
      errorCode: '',
      displayLabel: '',
      openPropertyDataModal: false,
      openDeletePropertyDataModal: false,
      openViewPropertyDataModal: false,
      mitigatedPropertyProjectSiteItem: '',
      mitigatedPropertyItem: {},
      mitigatedPropertyItemId: null,
      mitigatedPropertyToBeDeleted: '',
      openCancelModal: false,
    };
  }

  componentDidMount = () => {
    this.getInventoryList();
  };

  //creating a new item
  createProjectInventoryItem = async (item) => {
    const entityId = this.props.entityId;
    try {
      const response = await REST.location.createProjectInventoryItem(
        this.props.token,
        item,
        entityId,
        this.props.locationEntityType
      );

      const data = await forceJsonResponse(response, MONO);
      this.props.setProjectSiteDetailsInStore({
        inventoryItem: data,
        reducers: this.props.inventoryReducers,
      });

      this.setState({
        openModal: MODALS.MANAGE,
      });
    } catch (error) {
      this.setState({error: true});
    }
  };

  // //Open to with one entry's details, that can be edited
  getProjectSiteDetails = async (id) => {
    try {
      const response = await REST.location.getProjectSiteDetails(this.props.token, id);

      const data = await forceJsonResponse(response, MONO);
      this.props.setProjectSiteDetailsInStore({
        inventoryItem: data,
        reducers: this.props.inventoryReducers,
      });

      //remove dependendcy of inventoryItem in state
      this.setState({
        openModal: MODALS.MANAGE,
        inventoryItem: data,
      });
    } catch (error) {
      this.setState({error: true});
    }
  };

  getInventoryList = () => {
    this.setState({
      loading: true,
    });
    const entityId = this.props.entityId;
    REST.location
      .getInventoryList(this.props.token, entityId, this.props.locationEntityType)
      .then((response) => {
        if (response.status === 404) {
          return {};
        } else {
          return forceJsonResponse(response, FLUX);
        }
      })
      .then((propertySiteList) => {
        const inventoryList = _.get(propertySiteList, 'psiProjectSummaryView', []);
        const hasErrors = _.reduce(
          inventoryList,
          (result, item) => result || item.hasErrors,
          false
        );
        this.setState((prevState) => ({
          ...prevState,
          inventoryList,
          errorCode: '',
          loading: false,
        }));
        const {entityType, inventoryListIds, errorsPath, readOnly} = this.props;
        //extract list of id's
        const inventoryIds = _.map(inventoryList, 'locationId');
        //save ids and errors to redux store
        if (!readOnly) {
          this.props.saveManyEntityData([inventoryListIds, errorsPath], entityType, [
            inventoryIds,
            hasErrors,
          ]);
        }
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        if (error) {
          this.setState({error: true});
        }
      });
  };

  // Backend may take time to process after upload
  debouncedGetInventoryList = _.debounce(() => {
    this.getInventoryList();
  }, 250);

  uploadedFileData = (file) => {
    const entityId = this.props.entityId;
    var data = new FormData();
    data.append('fileName', file.file);
    this.setState({
      loading: true,
    });
    REST.location
      .uploadFileData(this.props.token, data, entityId, this.props.locationEntityType)
      .then((res) => forceJsonResponse(res, MONO))
      .then((res) => {
        const {errorCode, error = ''} = res;
        // Get Inventory list regardless of errorCode (some rows may still got processed)
        this.setState(
          {
            error: errorCode != undefined,
            errorCode: errorCode,
            errorText: error,
          },
          this.debouncedGetInventoryList
        );
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        if (error) {
          this.setState({error: true});
        }
      });
  };

  uploadAttachment = (attachmentType, files) => {
    this.setState((prevState) => ({...prevState, errorCode: ''}));
    if (!_.isEmpty(files)) {
      let file = files[0];
      this.uploadedFileData(file);
    }
    return Promise.reject();
  };

  disassociateProjectSite = (id) => {
    this.setState({loading: true});

    REST.location
      .disassociateProjectSite(this.props.token, id)
      .then((response) => forceJsonResponse(response, MONO))
      .then(() => {
        this.getInventoryList();
      })
      .catch((error) => {
        if (error) {
          this.setState({error: true});
        }
      });
  };

  retrieveAttachments = () => {
    return Promise.reject();
  };

  clearErrors = () => {
    this.setState((prevState) => ({...prevState, errorCode: ''}));
  };

  //put/update modified entry into DB
  //Open to with one entry's details, that can be edited
  updateProjectSiteDetails = (item) => {
    this.closeModal(false);
    this.setState({
      loading: true,
    });
    REST.location
      .updateProjectSiteDetails(this.props.token, item)
      .then(() => {
        this.getInventoryList();
      })
      .catch((error) => {
        if (error) {
          this.setState({error: true});
        }
      });
  };

  downloadInventoryTemplate = () => {
    const {templateDownloadPath} = this.props;
    REST.template
      .downloadInventoryTemplate(this.props.token, templateDownloadPath)
      .then((response) => {
        const filename = response.headers
          .get('Content-Disposition')
          .split('filename=')[1];
        response.blob().then((blob) => {
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement('a');
          a.href = url;
          a.download = _.trim(filename, '"');
          a.click();
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        if (error) {
          this.setState({error: true});
        }
      });
  };

  handleManageInventoryItem = (id, displayType, locationType) => {
    let displayLabel = _.get(PROPERTY_TYPES_LABELS, locationType);
    this.setState({
      modalType: displayType,
      locationType: locationType ? locationType : null,
      displayLabel: displayLabel,
    });

    if (displayType === 'edit' || displayType === 'view') {
      this.getProjectSiteDetails(id);
    } else {
      const locationTypeCode = _.chain(
        mapLocationRefDataByIdOrCode(
          _.get(this.props, 'context.propertyInventoryTypes.PROPERTY_INVENTORY_TYPE', []),
          'code'
        )
      )
        .find((t) => _.toLower(t.text).indexOf(locationType) > -1)
        .get('value')
        .value();
      let inventoryItem = _.merge(
        _.cloneDeep(NEW_ITEM),
        {
          structure: {
            inventoryType: locationType,
          },
        },
        this.props.newItemTemplate
      );
      this.createProjectInventoryItem(inventoryItem);
    }
  };

  handleDeleteInventory = (id) => {
    this.setState({
      openModal: MODALS.DELETE,
      itemToBeDeleted: id,
    });
  };

  // Not always need to re-retrieve list of inventory items
  closeModal = (getInventory = true) => {
    if (getInventory) {
      this.getInventoryList();
    }
    this.setState({
      openModal: MODALS.NONE,
      inventoryItem: {}, //reset inventory item
      itemToBeDeleted: '',
    });
  };

  confirmDeleteItem = () => {
    //call rest call to disassociate the project site location from project site
    this.disassociateProjectSite(this.state.itemToBeDeleted);
    //call rest call to reload all location, refresh list
    //this.getInventoryList();
    this.setState({itemToBeDeleted: ''});
    this.closeModal(false);
  };

  handleAddLocationMethodChange = (e) => {
    const {name, value} = e.target;
    this.setState({addLocationMethod: value});
  };

  createOrUpdateMitigatedPropertyData = async (id) => {
    let payload = _.get(this.props, 'context.mitigationPropertyData');
    if (this.state.mitigatedPropertyItemId) {
      await REST.location
        .updateMitigatedPropertyData(id, {payload})
        .then((response) => forceJsonResponse(response, MONO))
        .catch((error) => console.log(error));
    } else {
      await REST.location
        .createMitigatedPropertyData(id, {payload})
        .then((response) => forceJsonResponse(response, MONO))
        .catch((error) => console.log(error));
    }
    this.closePropertyDataModal();
  };

  getMitigatedPropertyData = async (actionType, locationId, mitigationId) => {
    const isEditModal = actionType === 'edit';
    const isViewModal = actionType === 'view';
    try {
      const response = await REST.location.getMitigatedPropertyData(locationId);
      const data = await forceJsonResponse(response, MONO);
      this.props.saveEntitySessionData('context.mitigationPropertyData', data.payload);
      this.setState({
        openPropertyDataModal: isEditModal,
        openViewPropertyDataModal: isViewModal,
        mitigatedPropertyItem: data,
        mitigatedPropertyItemId: mitigationId,
        mitigatedPropertyProjectSiteItem: locationId,
      });
      this.props.saveEntitySessionData('context.openPropertyDataModal', true);
    } catch (error) {
      console.log(error);
    }
  };

  handleMitigatedPropertyData = (actionType, locationId, mitigationId = null) => {
    if (actionType === 'edit' || actionType === 'view') {
      this.getMitigatedPropertyData(actionType, locationId, mitigationId);
    } else {
      this.setState({
        openPropertyDataModal: true,
        mitigatedPropertyProjectSiteItem: locationId,
      });
      this.props.saveEntitySessionData('context.openPropertyDataModal', true);
    }
  };

  disassociateMitigationProperty = (id) => {
    this.setState({loading: true});

    REST.location
      .deleteMitigatedPropertyData(id)
      .then((response) => forceJsonResponse(response, MONO))
      .then(() => {
        this.getInventoryList();
      })
      .catch((error) => console.log(error));
  };

  handleDeleteMitigatedPropertyData = (id) => {
    this.setState({
      openDeletePropertyDataModal: true,
      mitigatedPropertyToBeDeleted: id,
    });
  };

  confirmDeleteMitigatedPropertyData = () => {
    this.disassociateMitigationProperty(this.state.mitigatedPropertyToBeDeleted);
    this.setState({
      mitigatedPropertyToBeDeleted: '',
      openDeletePropertyDataModal: false,
    });
    this.closePropertyDataModal(false);
  };

  handlePropertyDataCancelAction = () => {
    this.setState({
      openCancelModal: true,
    });
  };

  closePropertyDataModal = (getInventory = true) => {
    if (getInventory) {
      this.getInventoryList();
    }
    this.props.saveEntitySessionData('context.mitigationPropertyData', null);
    this.setState({
      openDeletePropertyDataModal: false,
      openPropertyDataModal: false,
      openCancelModal: false,
      openViewPropertyDataModal: false,
      mitigatedPropertyItem: {},
      mitigatedPropertyItemId: null,
      mitigatedPropertyToBeDeleted: '',
      mitigatedPropertyProjectSiteItem: '',
    });
    this.props.saveEntitySessionData('context.openPropertyDataModal', false);
  };

  closeCancelModal = () => {
    this.setState({
      openCancelModal: false,
    });
  };

  doItemAction(actionType, item) {
    switch (actionType) {
      case 'edit':
        this.handleManageInventoryItem(item.locationId, 'edit', item.inventoryType);
        break;
      case 'delete':
        this.handleDeleteInventory(item.locationId);
        break;
      case 'editMitigatedPropertyData':
        this.handleMitigatedPropertyData('edit', item.locationId, item.mitigationDataId);
        break;
      case 'deleteMitigatedPropertyData':
        this.handleDeleteMitigatedPropertyData(item.locationId);
        break;
      case 'mitigatePropertyData':
        this.handleMitigatedPropertyData('initiate', item.locationId);
        break;
      default:
    }
  }

  noRowsError() {
    return (
      <React.Fragment>
        <Alert header="Error in Excel document:" type="error">
          <strong>
            Please make sure you input at least one location in the template.
          </strong>
        </Alert>
      </React.Fragment>
    );
  }

  isReadOnly() {
    let readOnly = false;
    if (this.props.readOnly === true) readOnly = true;
    return readOnly;
  }

  render() {
    const {inventoryList, inventoryItem, addLocationMethod, loading, error, errorText} =
      this.state;

    //Adding button labels in one string for automation selector
    const buttonVacantLand = 'Add vacant land';
    const buttonTextBuilding = 'Add a building';
    const buttonTextInfrastructure = 'Add infrastructure/utility/other';

    const contextTypes = {
      action: _.get(this.props, 'context.mitigationActionTypes.MITIGATION_ACTION', []),
      inventory: _.get(
        this.props,
        'context.propertyInventoryTypes.PROPERTY_INVENTORY_TYPE',
        []
      ),
      structure: _.get(this.props, 'context.structureTypes.STRUCTURE_TYPE', []),
    };

    const getDisplayType = (code, type) => {
      return _.chain(contextTypes[type])
        .find((t) => t.code === code)
        .get('displayText')
        .value();
    };

    const getMitigationActionName = (actions) => {
      let displayNames = [];
      if (actions && !_.isEmpty(contextTypes.action)) {
        displayNames = _.chain(_.split(actions, ','))
          .map((action) => {
            return _.get(
              _.find(contextTypes.action, (type) => type.code === _.trim(action)),
              'displayText'
            );
          })
          .compact()
          .value();
      }
      return _.join(displayNames, ', ');
    };

    const validationError =
      _.get(this.props, 'validationDirtyMap.dirty') &&
      getFirstObjectError(this.props.validationErrors);

    const mitigationPropertyValidationErrors = _.get(
      this.props,
      'dynamicComponent.validationErrors.errors.mitigationPropertyData.0.validations.isValid'
    );

    const {toggles, context} = this.props;
    const isMitigatedPropertySiteFundsPaid = _.get(
      context,
      'fundingOpportunityData.configData.foOverview.mitigatedPropertySiteFundsPaid'
    );
    const showMitigatedPropertyData = _.get(
      this.props,
      'propertyDataModalContents',
      null
    );
    const actionWidth =
      _.includes(toggles, 'enablePropertyDataMitigation') &&
      isMitigatedPropertySiteFundsPaid &&
      showMitigatedPropertyData
        ? 3
        : null;

    const editMitigatedPropertyDataOnly = _.get(
      this.props,
      'editMitigatedPropertyDataOnly',
      false
    );

    return (
      <div style={{overflow: 'auto'}} className="project-site-inventory-wrapper">
        <div className="util--full-width ui form location-method-select">
          {!editMitigatedPropertyDataOnly ? (
            <p>
              <strong>Enter the location of the property/structure.</strong>
            </p>
          ) : null}
          {!this.props.readOnly && !editMitigatedPropertyDataOnly ? (
            <InlineSelect
              label="Select a method for adding property/structure(s)."
              id="primary-mitigation-action-control"
              options={ADD_LOCATION_METHOD_CHANGE_OPTIONS}
              name="addLocationMethod"
              value={this.state.addLocationMethod}
              handleChange={this.handleAddLocationMethodChange}
            />
          ) : null}
        </div>
        {addLocationMethod === 'excel' && (
          <div id="upload-download-template" className="location-method">
            {error && errorText ? (
              <Alert header="Upload error" type="error">
                <strong>{errorText}</strong>
              </Alert>
            ) : (
              ''
            )}
            <p>
              Please&nbsp;
              <a
                href="https://www.fema.gov/media-collection/fema-grants-outcome-fema-go-hazard-mitigation-assistance-grants"
                target="_blank"
              >
                download the excel template
              </a>
              , and then fill out the template with building or infrastructure data.
            </p>
            <p>Please upload your completed template here.</p>
            <div onClick={this.clearErrors}>
              {this.state.errorCode === 'NO_ROWS' && this.noRowsError()}

              <Uploader
                uploadAttachment={this.uploadAttachment}
                acceptedFileTypes={['.xlsx']}
                resync={this.retrieveAttachments}
                updateRedux={this.retrieveAttachments}
                noFileDesc={true}
                attachmentType="project-site-inventory"
                fileSizeLimit={5}
              />
            </div>
          </div>
        )}
        {addLocationMethod === 'enter' && (
          <div id="enter-property-data" className="location-method">
            <Grid
              doubling
              columns={2}
              id="upload-download-template"
              className="staticText"
            >
              <div className="location-method">
                {' '}
                <p>
                  {' '}
                  Select “Add a building” if the subapplication proposes to mitigate
                  residential, commercial, industrial, government, education or other
                  non-infrastructure related buildings.
                </p>
                <Grid.Row>
                  <Grid.Column width={4}>
                    <Button
                      primary
                      onClick={() =>
                        this.handleManageInventoryItem(
                          null,
                          'add',
                          PROPERTY_TYPES_CODES.BUILDING
                        )
                      }
                    >
                      <Icon name="plus" /> {buttonTextBuilding}
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </div>
              <div className="location-method">
                {' '}
                <p>
                  {' '}
                  Select “Add infrastructure/utility/other” if the subapplication proposes
                  to mitigate energy, telecom/communication system, transportation, water
                  (potable), wastewater, water/flood control or other non-building related
                  infrastructure.
                </p>
                <Grid.Row>
                  <Grid.Column width={6}>
                    <Button
                      primary
                      onClick={() =>
                        this.handleManageInventoryItem(
                          null,
                          'add',
                          PROPERTY_TYPES_CODES.INFRASTRUCTURE
                        )
                      }
                    >
                      <Icon name="plus" /> {buttonTextInfrastructure}
                    </Button>
                  </Grid.Column>
                </Grid.Row>
              </div>

              <Toggle toggle="vacantLand">
                <div className="location-method">
                  {' '}
                  <p>
                    {' '}
                    Select “Add vacant land” if the subapplication proposes to mitigate
                    vacant land.
                  </p>
                  <Grid.Row>
                    <Grid.Column width={6}>
                      <Button
                        primary
                        onClick={() =>
                          this.handleManageInventoryItem(
                            null,
                            'add',
                            PROPERTY_TYPES_CODES.VACANTLAND
                          )
                        }
                      >
                        <Icon name="plus" /> {buttonVacantLand}
                      </Button>
                    </Grid.Column>
                  </Grid.Row>
                </div>
              </Toggle>
            </Grid>
          </div>
        )}
        <FemaGoModal
          title={`Add ${this.state.displayLabel} information`}
          type="alert"
          size="large"
          open={this.state.openModal === MODALS.MANAGE}
          closeOnDimmerClick="no"
          confirmButton="hidden"
          confirmAction={() => {}}
          cancelAction={() => this.closeModal()}
          cancelButtonText="Close"
        >
          {!_.isEmpty(inventoryItem) || this.state.modalType === 'add' ? (
            <ProjectSiteItem
              item={inventoryItem}
              displayType={this.state.modalType}
              readOnly={this.props.readOnly}
              showUnsubmitted={this.props.showUnsubmitted}
              locationType={
                this.state.locationType ||
                _.toLower(inventoryItem.structure.inventoryType)
              }
              reducers={this.props.inventoryReducers}
              dataPath={this.props.dataPath}
              token={this.props.token}
              includeNatureBasedSolutions={!!_.get(this.props, 'newItemTemplate')}
            />
          ) : (
            <Dimmer active inverted>
              <Loader inline="centered" active>
                Loading...
              </Loader>
            </Dimmer>
          )}
        </FemaGoModal>
        <DeleteModal
          displayTitle={'Remove item'}
          open={this.state.openModal === 'delete'}
          cancelAction={() => this.closeModal(false)}
          deleteAction={() => this.confirmDeleteItem()}
          displayText="Are you sure you want to remove this item?"
        />
        {_.includes(toggles, 'enablePropertyDataMitigation') &&
          isMitigatedPropertySiteFundsPaid &&
          showMitigatedPropertyData && (
            <>
              <FemaGoModal
                title={`Add property data`}
                size="large"
                open={this.state.openPropertyDataModal}
                closeOnDimmerClick="no"
                buttonText="Add property data"
                disableButton={!mitigationPropertyValidationErrors}
                confirmAction={() =>
                  this.createOrUpdateMitigatedPropertyData(
                    this.state.mitigatedPropertyProjectSiteItem
                  )
                }
                cancelAction={() => this.handlePropertyDataCancelAction()}
                cancelButtonText="Cancel"
              >
                <React.Fragment>
                  {_.map(this.props.propertyDataModalContents, (conf, index) => {
                    let config = {
                      ...conf,
                    };
                    return <ContentDispatch key={conf.id || index} config={config} />;
                  })}
                </React.Fragment>
              </FemaGoModal>
              <FemaGoModal
                title={`View property data`}
                size="large"
                open={this.state.openViewPropertyDataModal}
                closeOnDimmerClick="no"
                buttonText=""
                confirmButton="hidden"
                confirmAction={() => {}}
                cancelAction={() => this.closePropertyDataModal(false)}
                cancelButtonText="Close"
              >
                <React.Fragment>
                  {_.map(this.props.propertyDataModalContents, (conf, index) => {
                    let config = {
                      ...conf,
                    };
                    return <ContentDispatch key={conf.id || index} config={config} />;
                  })}
                </React.Fragment>
              </FemaGoModal>
              <DeleteModal
                id="confirmDeleteMitigatedPropertyData"
                displayTitle={'Remove item'}
                open={this.state.openDeletePropertyDataModal}
                cancelAction={() => this.closePropertyDataModal(false)}
                deleteAction={() => this.confirmDeleteMitigatedPropertyData()}
                displayText="Are you sure you want to remove this item?"
              />
              <FemaGoModal
                title={`Are you sure you want to cancel?`}
                type="alert"
                open={this.state.openCancelModal}
                closeOnDimmerClick="no"
                buttonText="Cancel"
                confirmAction={() => this.closePropertyDataModal()}
                cancelAction={() => this.closeCancelModal()}
                cancelButtonText="Go back"
              >
                <p>
                  By clicking cancel, you will lose any saved changes made to the current
                  Property data.
                </p>
              </FemaGoModal>
            </>
          )}
        {loading ? (
          <Loader inline="centered" active>
            Loading...
          </Loader>
        ) : (
          <div id="project-site-inventory-list">
            {_.get(validationError, 'message') && (
              <Alert type="error">
                <strong> {validationError.message} </strong>
              </Alert>
            )}
            {inventoryList.length > 0 && (
              <React.Fragment>
                <div className="textMedium staticText">
                  {' '}
                  <strong>List of location(s) </strong>
                  {`(${inventoryList.length} location${
                    inventoryList.length > 1 ? 's' : ''
                  })`}
                </div>
                <FemaGoTable type="static" summary="List of locations">
                  <FemaGoTable.Header>
                    <FemaGoTable.Row>
                      <FemaGoTable.HeaderCell>Status</FemaGoTable.HeaderCell>
                      <FemaGoTable.HeaderCell>Location ID</FemaGoTable.HeaderCell>
                      <FemaGoTable.HeaderCell>Address</FemaGoTable.HeaderCell>
                      <FemaGoTable.HeaderCell>Inventory type</FemaGoTable.HeaderCell>
                      <FemaGoTable.HeaderCell>Structure type</FemaGoTable.HeaderCell>
                      <FemaGoTable.HeaderCell>Mitigation action</FemaGoTable.HeaderCell>
                      {_.includes(toggles, 'enablePropertyDataMitigation') &&
                        isMitigatedPropertySiteFundsPaid &&
                        showMitigatedPropertyData && (
                          <FemaGoTable.HeaderCell>
                            Mitigation status entered?
                          </FemaGoTable.HeaderCell>
                        )}
                      {!this.isReadOnly() && (
                        <FemaGoTable.HeaderCell width={actionWidth}>
                          Action
                        </FemaGoTable.HeaderCell>
                      )}
                    </FemaGoTable.Row>
                  </FemaGoTable.Header>
                  <FemaGoTable.Body>
                    {_.map(inventoryList, (item, index) => {
                      let actions = [];
                      if (!editMitigatedPropertyDataOnly) {
                        actions.push({
                          key: 'edit',
                          text: 'Edit',
                          value: 'edit',
                        });
                        actions.push({
                          key: 'delete',
                          text: 'Delete',
                          value: 'delete',
                        });
                      }

                      if (
                        _.includes(toggles, 'enablePropertyDataMitigation') &&
                        isMitigatedPropertySiteFundsPaid &&
                        showMitigatedPropertyData
                      ) {
                        if (_.get(item, 'mitigationDataId', null)) {
                          actions.push({
                            key: 'editMitigatedPropertyData',
                            text: 'Edit mitigated property data',
                            value: 'editMitigatedPropertyData',
                          });
                          actions.push({
                            key: 'deleteMitigatedPropertyData',
                            text: 'Delete mitigated property data',
                            value: 'deleteMitigatedPropertyData',
                          });
                        } else {
                          actions.push({
                            key: 'mitigatePropertyData',
                            text: 'Mitigate property data',
                            value: 'mitigatePropertyData',
                          });
                        }
                      }
                      return (
                        <FemaGoTable.Row key={index}>
                          <FemaGoTable.StatusCell
                            hasErrors={item.hasErrors}
                            float={'left'}
                            cellID={item.locationId}
                          >
                            {item.hasErrors}
                          </FemaGoTable.StatusCell>
                          <FemaGoTable.TextCell>
                            <a
                              href="#"
                              onClick={() =>
                                this.handleManageInventoryItem(
                                  item.locationId,
                                  'view',
                                  item.inventoryType
                                )
                              }
                            >
                              {item.locationId}
                            </a>
                          </FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>{item.address}</FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>
                            {getDisplayType(item.inventoryType, 'inventory')}
                          </FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>
                            {getDisplayType(item.structureType, 'structure')}
                          </FemaGoTable.TextCell>
                          <FemaGoTable.TextCell>
                            {getMitigationActionName(item.mitigationAction)}
                          </FemaGoTable.TextCell>
                          {_.includes(toggles, 'enablePropertyDataMitigation') &&
                            isMitigatedPropertySiteFundsPaid &&
                            showMitigatedPropertyData && (
                              <FemaGoTable.TextCell>
                                {_.get(item, 'mitigationDataId', null) ? (
                                  <a
                                    href="#"
                                    onClick={() =>
                                      this.handleMitigatedPropertyData(
                                        this.isReadOnly() ? 'view' : 'edit',
                                        item.locationId,
                                        item.mitigationDataId
                                      )
                                    }
                                  >
                                    {'Yes'}
                                  </a>
                                ) : (
                                  'No'
                                )}
                              </FemaGoTable.TextCell>
                            )}
                          {!this.isReadOnly() ? (
                            <FemaGoTable.TextCell textAlign="left">
                              <Dropdown
                                selectOnNavigation={false}
                                selectOnBlur={false}
                                text={'Actions'}
                                name={`${item.locationId}-action-button`}
                                id={`${item.locationId}-action-button`}
                                onChange={(e, {name, value}) =>
                                  this.doItemAction(value, item)
                                }
                                upward={_.size(inventoryList) - index < 3}
                                options={actions}
                                value={''}
                              />
                            </FemaGoTable.TextCell>
                          ) : null}
                        </FemaGoTable.Row>
                      );
                    })}
                  </FemaGoTable.Body>
                </FemaGoTable>
              </React.Fragment>
            )}
          </div>
        )}
      </div>
    );
  }
}

export const mapDispatchToProps = (dispatch) => ({
  setProjectSiteDetailsInStore: (payload) => {
    return dispatch({
      type: SET_LOCATION_SITE_STORE,
      data: payload,
    });
  },

  removeProjectSiteDetailsFromStore: () => {
    return dispatch({
      type: REMOVE_LOCATION_SITE_STORE,
    });
  },
});

export const mapStateToProps = (state) => {
  return {
    dynamicComponent: state.dynamicComponent,
    context: state.dynamicComponent.context,
    token: state.auth.token,
    // TODO remove OpenAPI toggle code
    locationV2: unpartitionedToggleIsOn(state, 'locationV2'),
    toggles: state.toggles.toggles,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDynamic(ProjectSiteInventory));
